import { render, staticRenderFns } from "./RentabilidadeList.vue?vue&type=template&id=bfa6695a&scoped=true"
import script from "./RentabilidadeList.vue?vue&type=script&lang=js"
export * from "./RentabilidadeList.vue?vue&type=script&lang=js"
import style0 from "./RentabilidadeList.vue?vue&type=style&index=0&id=bfa6695a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6695a",
  null
  
)

export default component.exports